import { Modal } from "react-bootstrap";

const LoadingModal = ({ active = false }) => {
  return (
    <Modal show={active} backdrop="static" keyboard={false}>
      <Modal.Body>Please wait...</Modal.Body>
    </Modal>
  );
};

export default LoadingModal;
